import { Component, EventEmitter, Output } from '@angular/core';
import { Period } from '../models/Period';
import { PeriodFilter } from '../models/PeriodFilter';
import { SearchFilterBuilderService } from '../services/search-filter-builder.service';

@Component({
  selector: 'filter-periods',
  templateUrl: 'filter-periods.component.html',
  styleUrls: ['filter-periods.component.css']
})
export class FilterPeriodsComponent {

  @Output() init = new EventEmitter<PeriodFilter>();
  @Output() periodChange = new EventEmitter<PeriodFilter>();

  constructor(private searchFilterBuilderService: SearchFilterBuilderService) { }

  startDate!: Date;
  endDate!: Date;
  currentPeriod!: Period;

  ngOnInit() {
    this.setTodayDates(true);
  }

  get periods() {
    return Period;
  }

  reset() {
    this,this.currentPeriod = Period.none;
  }

  raiseEvent(init?: boolean) {
    if (init)
      this.initRequest();
    else
      this.periodChangeRequest();
  }

  initRequest() {
    this.init.emit(this.period);
  }

  periodChangeRequest() {
    this.periodChange.emit(this.period);
  }

  get period() {
    return {
      startDate: this.startDate,
      endDate: this.endDate
    };
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  get previousYear() {
    return new Date().getFullYear() - 1;
  }

  active(period: Period) {
    return this.currentPeriod == period;
  }

  setTodayDates(init?: boolean) {
    const today = new Date();

    this.startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    this.endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    this.currentPeriod = Period.today;

    this.raiseEvent(init);
  }

  setYesterdayDates(init?: boolean) {
    const today = new Date();
    const pastDate = this.searchFilterBuilderService.addDays(today, -1);
    this.startDate = new Date(pastDate.getFullYear(), pastDate.getMonth(), pastDate.getDate());
    this.endDate = new Date(pastDate.getFullYear(), pastDate.getMonth(), pastDate.getDate());
    this.currentPeriod = Period.yesterday;

    this.raiseEvent(init);
  }

  setCurrentMonthDates(init?: boolean) {
    const today = new Date();
    
    this.startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    this.currentPeriod = Period.currentMonth;

    this.raiseEvent(init);
  }

  setLastDaysDates(days: number, init?: boolean) {
    const today = new Date();
    const pastDate = this.searchFilterBuilderService.addDays(today, -days);
    this.startDate = new Date(pastDate.getFullYear(), pastDate.getMonth(), pastDate.getDate());
    this.endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    switch (days) {
      case 7:
        this.currentPeriod = Period.last7Days;
        break;
      case 30:
        this.currentPeriod = Period.last30Days;
        break;
      case 90:
        this.currentPeriod = Period.last90Days;
        break;
      case 180:
        this.currentPeriod = Period.last180Days;
        break;
    }

    this.raiseEvent(init);
  }

  setCurrentYearDates(init?: boolean) {
    var today = new Date();
    
    this.startDate = new Date(today.getFullYear(), 0, 1);
    this.endDate = new Date(today.getFullYear(), 11, 31);
    this.currentPeriod = Period.currentYear;

    this.raiseEvent(init);
  }

  setPreviousYearDates(init?: boolean) {
    var today = new Date();
    
    this.startDate = new Date(today.getFullYear() - 1, 0, 1);
    this.endDate = new Date(today.getFullYear() - 1, 11, 31);
    this.currentPeriod = Period.previousYear;

    this.raiseEvent(init);
  }
}
